<div *ngFor="let formularz of formularze;index as i">
    <shared-formularz
            [formularzId]="formularz.id"
            [formularzUszkodzenia]="formularz.formularz"
            [formularzWidoczny]="formularzWidoczny"
            [rodzajePowierzchni]="elementUszkodzenia.rodzajePowierzchni"
            [rodzajeMaterialowWykonczenia]="elementUszkodzenia.materialyWykonczenia"
            [jednostkaPowierzchniUszkodzenia]="elementUszkodzenia.jednostka"
            [czyPosiadaAtrybuty]="!!elementUszkodzenia.atrybuty"
            [pokazWysokosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazWysokosc : false"
            [pokazSzerokosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazSzerokosc : false"
            [pokazWartosc]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazWartosc : false"
            [pokazFolieReklamowa]="elementUszkodzenia.atrybuty ? elementUszkodzenia.atrybuty.pokazFolieReklamowa : false"
            [minimalnaWysokosc]="this.minimalnyWymiar || elementUszkodzenia.minimalnaWartoscUszkodzenia || minimalnaWartosc"
            [maksymalnaWysokosc]="this.maksymalnyWymiar || elementUszkodzenia.maksymalnaWartoscUszkodzenia || maksymalnaWartosc"
            [minimalnaSzerokosc]="this.minimalnyWymiar || elementUszkodzenia.minimalnaWartoscUszkodzenia || minimalnaWartosc"
            [maksymalnaSzerokosc]="this.maksymalnyWymiar || elementUszkodzenia.maksymalnaWartoscUszkodzenia || maksymalnaWartosc"
            [minimalnaWartoscUszkodzenia]="elementUszkodzenia.minimalnaWartoscUszkodzenia"
            [maksymalnaWartoscUszkodzenia]="elementUszkodzenia.maksymalnaWartoscUszkodzenia || maksymalneWartosci[i].maksymalnaWartoscUszkodzenia"
            [domyslnaWartoscUszkodzenia]="elementUszkodzenia.domyslnaWartoscUszkodzenia"
            [czyWalidacjaWgPowierzchni]="czyWalidacjaWgPowierzchni"
            (wyczyscFormularz)="wyczyscPodformularz($event)"
            (zmianaFormularza)="aktualizujFormularz($event)">
    </shared-formularz>
</div>

<div class="d-block filled-100" *ngIf="formularzWidoczny && formularze.length !== elementUszkodzenia.maksymalnaIloscElementow">
    <div class="o-flex o-flex--grids mb-3">
        <div class="o-flex__item u-flex-1/1 ">
            <div class="c-card c-card-sm ">
                <div (click)="dodajFormularzUszkodzenia()" class="text text-blue-color mb-0 c-pointer">
                    + Dodaj {{elementUszkodzenia.opis}}
                </div>
            </div>
        </div>
    </div>
</div>
